import { render, staticRenderFns } from "./research-team.vue?vue&type=template&id=572b47b0&scoped=true&"
import script from "./research-team.vue?vue&type=script&lang=js&"
export * from "./research-team.vue?vue&type=script&lang=js&"
import style0 from "./research-team.vue?vue&type=style&index=0&id=572b47b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572b47b0",
  null
  
)

component.options.__file = "research-team.vue"
export default component.exports